import React, { useContext, useEffect, useState } from 'react'
import LogContext from '../context/LogContext';
import cLogo from '../media/kidoriseLogo.png'
import axios from 'axios';
const backendUrl = process.env.REACT_APP_BACKEND_URL;
const adminUrl = process.env.REACT_APP_ADMIN_BACKEND_URL;

export default function Checkout({ selectedCoupon, isCheckout, setIsCheckout }) {
    const myContext = useContext(LogContext);
    const [savedAddresses, setSavedAddresses] = useState([]);
    const [name, setName] = useState('');
    const [phone, setPhone] = useState('');
    const [pincode, setPincode] = useState('');
    const [locality, setLocality] = useState('');
    const [areaNstreet, setAreaNstreet] = useState('');
    const [city, setCity] = useState('');
    const [state, setState] = useState('');
    const [landmark, setLandmark] = useState('');
    const [alternatePhone, setAlternatePhone] = useState('');
    const [addressType, setAddressType] = useState('');
    const [canSave, setCanSave] = useState(true);
    const [addNew, setAddNew] = useState();
    const [item, setItem] = useState([]);
    const [selectedAddress, setSelectedAddress] = useState();
    const [totalQuantity, setTotalQuantity] = useState();
    const [totalValue, setTotalValue] = useState();
    const [couponDiscount, setCouponDiscount] = useState(0);
    const [bagDiscount, setBagDiscount] = useState(0);
    const [totalSavings, setTotalSavings] = useState()
    const getUserAddresses = async () => {
        try {
            const response = await fetch(`${backendUrl}/getUserAddresses`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ email: myContext.user.email }),
            });
            if (response.ok) {
                const data = await response.json();
                setSavedAddresses(data.data);
            } else {
                console.log('Data fetch unsuccessful');
            }
        } catch (error) {
            console.error('Error fetching user addresses:', error);
        }
    };
    const handelRadio = (e) => {
        setAddressType(e.target.value);
    };

    const handelSave = async () => {
        const address = { name, phone, pincode, locality, areaNstreet, city, state, landmark, alternatePhone, addressType };
        try {
            const response = await fetch(`${backendUrl}/saveAddress`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ email: myContext.user.email, address })
            });
            if (response.ok) {
                const data = await response.json();
                window.location.reload();
                setAddNew(false);
            } else {
                console.error('Failed to save');
            }
        } catch (error) {
            console.error('An error occurred:', error);
        }
    };
    const handelDelete = async (index) => {
        try {
            const response = await fetch(`${backendUrl}/deleteSavedAddress`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ email: myContext.user.email, index }),
            });
            if (response.ok) {

                window.location.reload();
            } else {
                console.log('Error deleting address');
            }
        } catch (error) {
            console.error('An error occurred while deleting address:', error);
        }
    };
    const getCurrentLocation = () => {
        if (navigator.geolocation) {
            navigator.geolocation.getCurrentPosition(
                async (position) => {
                    const { latitude, longitude } = position.coords;
                    try {
                        const response = await axios.get(`${backendUrl}/geocode?lat=${latitude}&lng=${longitude}`);
                        console.log(response.data.results[0])
                        if (response.data && response.data.results && response.data.results.length > 0) {
                            const addressDetails = response.data.results[0];
                            console.log(addressDetails)
                            setAreaNstreet(addressDetails.formatted_address)
                            setLocality(getAddressComponent(addressDetails, 'sublocality_level_1'));
                            setCity(getAddressComponent(addressDetails, 'locality'));
                            setState(getAddressComponent(addressDetails, "administrative_area_level_1"))
                            setPincode(getAddressComponent(addressDetails, 'postal_code'));
                        }
                    } catch (error) {
                        console.error('Error fetching current location:', error);
                    }
                },
                (error) => {
                    console.error('Error getting current location:', error);
                }
            );
        } else {
            console.error('Geolocation is not supported by this browser.');
        }
    };

    const getAddressComponent = (addressDetails, type) => {
        const component = addressDetails.address_components.find((component) => component.types.includes(type));
        console.log(component.long_name)
        return component ? component.long_name : '';
    };

    const getCheckOutItems = async () => {
        if (localStorage.getItem('from') === 'product') {
            try {
                const data = await fetch(`${backendUrl}/getProduct/${localStorage.getItem('currentProduct')}`, {
                    method: 'GET',
                    headers: {
                        "Content-Type": "application/json"
                    }
                });
                const productDetails = await data.json();
                setItem(productDetails['data'][0]);
            } catch (error) {
                console.log("error", error)
            }
        }
        else {
            try {
                const response = await fetch(`${backendUrl}/cartData`, {
                    method: "POST",
                    headers: {
                        "content-type": "application/json"
                    },
                    body: JSON.stringify({ email: myContext.user.email })
                });
                if (response.ok) {
                    const productArray = await response.json();
                    setItem(productArray.cartItems);
                } else {
                    console.log("Can't retrieve data from the user collections in the database");
                }
            } catch (error) {
                console.error("Error fetching cart data:", error);
            }
        }

    };




    const verifyPayment = async (razorpay_payment_id, razorpay_order_id, razorpay_signature) => {
        try {
            const response = await fetch('http://localhost:8001/verifyPayment', {
                method: 'POST',
                headers: {
                    "content-type": 'application/json'
                },
                body: JSON.stringify({ razorpay_payment_id, razorpay_order_id, razorpay_signature, email: myContext.user.email })
            });
            if (response.ok) {
                alert("Order placed successfully!")
                window.location.href = "/Cart"

            }
        } catch (error) {
            console.log("Some error occured", error)
        }
    }

    const handlePaymentFaliure = async (razorpay_payment_id) => {
        try {
            const response = await fetch('http://localhost:8001/paymentFailure', {
                method: 'POST',
                headers: {
                    "content-type": 'application/json'
                },
                body: JSON.stringify({ razorpay_payment_id, email: myContext.user.email })
            });
            if (response.ok) {
                alert("Try again!");
                window.location.reload();
            }
        } catch (error) {
            console.log("Some error occured", error)
        }
    }

    // RazorPay Scripting ====>>>

    const handlePayOut = async () => {
        try {
            const response = await fetch(`${backendUrl}/createOrder`, {
                method: 'POST',
                headers: {
                    "content-type": "application/json"
                },
                body: JSON.stringify({ products: item, email: myContext.user.email, address: savedAddresses[selectedAddress], name: myContext.user.firstName + " " + myContext.user.lastName, coupon: selectedCoupon, couponDiscount })
            });
            if (response.ok) {
                const data = await response.json();
                const order = data.razorpayOrder;
                const options = {
                    key: 'rzp_live_Rgke7qZqXOYrWl', // Enter the Key ID generated from the Dashboard
                    amount: order.amount, // Amount is in currency subunits. Default currency is INR. Hence, 50000 refers to 50000 paise
                    currency: 'INR',
                    name: 'Kidorise', // Your business name
                    description: 'Test Transaction',
                    image: { cLogo },
                    order_id: order.id, // This is a sample Order ID. Pass the `id` obtained in the response of Step 1
                    handler: function (response) {
                        verifyPayment(response.razorpay_payment_id,
                            response.razorpay_order_id,
                            response.razorpay_signature)
                    },
                    prefill: {
                        name: myContext.user.firstName, // Your customer's name
                        email: myContext.user.email,
                        contact: myContext.user.mobile, // Provide the customer's phone number for better conversion rates
                    },
                    notes: {
                        address: 'Razorpay Corporate Office',
                    },
                    theme: {
                        color: '#3399cc',
                    },
                    modal: {
                        ondismiss: function () {
                            handlePaymentFaliure(order.id)
                        },
                    }
                };
                const rzp1 = new window.Razorpay(options);
                rzp1.on('payment.failed', function (response) {
                    handlePaymentFaliure(response.razorpay_payment_id)
                });
                rzp1.open();
            }
            else {
                console.log("Can't generate Order");
            }
        } catch (error) {
            console.log("Error generating Order")
        }
    }
    useEffect(() => {
        // Load the Razorpay checkout script
        const script = document.createElement('script');
        script.src = 'https://checkout.razorpay.com/v1/checkout.js';
        script.async = true;
        document.body.appendChild(script);

        // Cleanup script when component unmounts
        return () => {
            document.body.removeChild(script);
        };
    }, []);

    useEffect(() => {
        if (myContext.user.email) {
            getUserAddresses(myContext.user.email);
            getCheckOutItems();
        }
    }, [myContext.user.email]);

    useEffect(() => {
        if (name && phone && pincode && locality && areaNstreet && city && state && addressType) {
            setCanSave(false);
        }
    });
    function sum(total, element) {
        return total + (element.quantity) * (parseFloat(element.pricing.MRP))
    }
    function offAmount(total, element) {
        return total + (parseFloat(element.quantity) * (parseFloat(element.pricing.MRP) - parseFloat(element.pricing.offerPrice)));
    }
    useEffect(() => {
        if (localStorage.getItem('from') === "cart" && item.length) {
            setTotalValue(item.reduce(sum, 0));
            setTotalQuantity(item.reduce((sum, product) => sum + Number(product.quantity), 0));
            setBagDiscount(item.reduce(offAmount, 0));
            const coupon = selectedCoupon;
            let discount = 0;
            if (coupon) {
                if (coupon.discountType === 'fixed') {
                    discount = coupon.discountValue;
                } else if (coupon.discountType === 'percentage') {
                    discount = (totalValue - bagDiscount) * (coupon.discountValue / 100);
                }
            }
            setCouponDiscount(discount);
        }
    }, [selectedCoupon, item])

    return (
        <div className='checkout' >
            <div className='back'>
                <button className='btn btn-back' onClick={() => setIsCheckout(false)}>
                    <i class="fa-solid fa-arrow-left"></i>
                </button>

            </div>
            <div className='row'>
                <div className='col-sm-8 col-xs-12'>
                    <div className='checkout-list'>
                        <div className='checkout-item'>
                            <p className='head'>
                                <span className='bullitin'>1.</span>
                                <span className='head-content'>LOGIN <i class="fa-solid fa-check"></i></span>
                                {/* <button className='pull-right btn-change'>CHANGE</button> */}
                            </p>
                            <p className='info' style={{ textTransform: 'none' }}>
                                <span style={{ color: '#5f5b57', fontWeight: "500", marginLeft: '4rem' }}>Name : </span>{myContext.user.firstName}
                                &nbsp; &nbsp;
                                <span style={{ color: '#5f5b57', fontWeight: "500" }}>As : </span>
                                {myContext.user.email}
                            </p>
                        </div>
                    </div>
                    <div className='checkout-list'>
                        <div className='checkout-item'>
                            <p className='head'>
                                <span className='bullitin'>2.</span>
                                <span className='head-content'>DELIVERY ADDRESS <i class="fa-solid fa-check"></i></span><br /><br />
                                <div className='new-address'>
                                    <span className='head'><i className='fa-solid fa-plus' style={{ cursor: 'pointer' }} onClick={() => setAddNew(true)}></i> &nbsp;ADD A NEW ADDRESS</span>
                                    {addNew && (
                                        <>
                                            <div>
                                                {/* <div className='current-location'>
                                                    <button className='btn-location' onClick={getCurrentLocation}>
                                                        <i className='fa-solid fa-location-crosshairs'></i> Use my current location
                                                    </button>
                                                </div> */}
                                            </div>
                                            <div className='address-form' style={{ marginTop: '1.5rem' }} >
                                                <input className='inp-small' type='text' name='name' placeholder='Name' onChange={(e) => setName(e.target.value)} />
                                                <input className='inp-small' type='text' name='phone' placeholder='10-digit mobile number' onChange={(e) => setPhone(e.target.value)} />
                                                <br />
                                                <input className='inp-small' type='text' name='pincode' placeholder='Pincode' value={pincode} onChange={(e) => setPincode(e.target.value)} />
                                                <input className='inp-small' type='text' name='locality' placeholder='Locality' value={locality} onChange={(e) => setLocality(e.target.value)} />
                                                <br />
                                                <textarea className='inp-big' type='text' name='address' placeholder='Address (Area and Street)' value={areaNstreet} onChange={(e) => setAreaNstreet(e.target.value)} />
                                                <br />
                                                <input className='inp-small' type='text' name='city' placeholder='City/District/Town' value={city} onChange={(e) => setCity(e.target.value)} />
                                                <input className='inp-small' type='text' name='state' placeholder='State' value={state} onChange={(e) => setState(e.target.value)} />
                                                <br />
                                                <input className='inp-small' type='text' name='landmark' placeholder='Landmark (Optional)' onChange={(e) => setLandmark(e.target.value)} />
                                                <input className='inp-small' type='text' name='alternate-phone' placeholder='Alternate Phone (Optional)' onChange={(e) => setAlternatePhone(e.target.value)} />
                                                <p className='address-type'>Address Type</p>
                                                <input className='radioo' type='radio' name='addressType' id='home' value='Home' checked={addressType === 'Home'} onChange={handelRadio} />
                                                <label className='radio-label' style={{ color: 'rgb(132, 210, 230)' }} htmlFor='home'>Home</label>
                                                <input className='radioo' type='radio' name='addressType' id='work' value='Work' checked={addressType === 'Work'} onChange={handelRadio} />
                                                <label className='radio-label' style={{ color: 'rgb(132, 210, 230)' }} htmlFor='work'>Work</label>
                                                <br />
                                                <button className='save-btn' onClick={handelSave} disabled={canSave}>Save</button>
                                                <button className='cancel-btn' onClick={() => setAddNew(false)}>Cancel</button>
                                            </div>
                                        </>
                                    )}
                                </div>
                            </p>{
                                savedAddresses.map((address, index) => (
                                    <div className='checkout-addresses'>
                                        <div className='address'>
                                            <input type="radio" name="selectedAddress" id="" checked={selectedAddress === index} onChange={() => { setSelectedAddress(index) }} />
                                            <div className='col-9'><p className='info'>{address.areaNstreet}</p></div>
                                            <div className='col-3'><button className='pull-right'><i class="fa-solid fa-trash" onClick={() => { handelDelete(index) }}></i></button></div>
                                        </div>
                                    </div>
                                ))
                            }
                        </div>
                    </div>
                    <div className='checkout-list'>
                        <div className='checkout-item'>
                            <p className='head'>
                                <span className='bullitin'>3.</span>
                                <span className='head-content'>ORDER SUMMERY <i class="fa-solid fa-check"></i></span>
                            </p>
                            {(item && selectedAddress != undefined && localStorage.getItem('from') === "product") &&
                                <div className='products'>
                                    <div className='product' style={{ display: 'flex' }}>
                                        <img className='image' src={`${adminUrl}/uploads/products/${item.images[0].preview}`} alt="" />
                                        <div className='details'>
                                            <p className='name'>{item.name}</p>
                                            <div className='assurence' style={{ display: 'flex' }}>
                                                <p className='ratings'> <button className='rating-tag'>{item.ratings} <span style={{ fontSize: "12px" }}><i class="fa-solid fa-star"></i></span></button></p>
                                                <p className='siprijaLogo'>
                                                    <img className='image' src={cLogo} alt="" />
                                                    Assured
                                                </p>
                                            </div>
                                            <p className='pricing'>
                                                <span className='offer-price'>&#8377; {item.offerPrice}</span>
                                                <span className='old-price'>&#8377; {item.MRP}</span>
                                                <span className='offpercent'>{item.discount_percentage}% off</span>
                                            </p>

                                        </div>
                                    </div>
                                </div>}
                            {(item && selectedAddress != undefined) &&
                                item.map((item) => (
                                    <div className='products' key={item._id}>
                                        <div className='product' style={{ display: 'flex' }}>
                                            <img className='image' src={`${adminUrl}/uploads/products/${item.images[0].preview}`} alt="" />
                                            <div className='details'>
                                                <div className='starts single-feature-txt' style={{ marginTop: '.9rem' }} >
                                                    <p>
                                                        <i className="fa fa-star" style={{ color: '#f7a5b9' }}></i>
                                                        <i className="fa fa-star" style={{ color: '#f7a5b9' }}></i>
                                                        <i className="fa fa-star" style={{ color: '#f7a5b9' }}></i>
                                                        <i className="fa fa-star" style={{ color: '#f7a5b9' }}></i>
                                                        <span className="spacial-feature-icon"><i className="fa fa-star"></i></span>
                                                    </p>
                                                </div>
                                                <p className='name'>{item.title}</p>
                                                <p className='pricing'>
                                                    <span className='offer-price'>&#8377; {item.pricing.offerPrice}</span>
                                                    <span className='old-price'>&#8377;{item.pricing.MRP}</span>
                                                    <span className='offpercent'>{item.discount_percentage}% off</span>
                                                    <span className='quantity'><button disabled>Qty {item.quantity}</button> </span>
                                                </p>

                                            </div>
                                        </div>
                                    </div>
                                ))
                            }
                            {selectedAddress != undefined && <button className='btn-cart welcome-add-cart' style={{ marginLeft: "2rem" }} onClick={handlePayOut}>Continue</button>}
                        </div>
                    </div>
                    <div className='checkout-list'>
                        <div className='checkout-item'>
                            <p className='head'>
                                <span className='bullitin'>4.</span>
                                <span className='head-content'>PAYMENT OPTIONS <i class="fa-solid fa-check"></i></span>
                                {/* <button className='pull-right btn-change'>CHANGE</button> */}
                            </p>
                        </div>
                    </div>

                </div>
                <div className='col-sm-4 col-xs-12'>

                    <div className='price-details'>
                        {localStorage.getItem('from') === 'product' ? <>
                            <p className='head'>Biling Details</p>
                            <hr />
                            <p className='context'>1 item <span className='pull-right'>&#8377; {item && item.offerPrice}</span></p>
                            <p className='context'>Shipping Charges
                                <span className='pull-right'>
                                    <span>&#8377; 120</span>
                                </span></p>
                            <hr />
                            <p className='total-payable'>Total Payable <span className='pull-right'>&#8377; {item ? Number(item.offerPrice) + 120 : ""}</span></p>
                            <hr />
                            <p className='saving-alert' style={{ color: 'rgb(27, 138, 75);' }}>
                                Total Saving on this order &#8377; { }
                            </p>
                        </> :
                            <>
                                <p className='head'>Billing Details</p>
                                <hr />
                                <p className='context'>{totalQuantity} item <span className='pull-right'>&#8377; {totalValue}</span></p>
                                <p className='context'>Bag Discount
                                    <span className='pull-right'>
                                        <span className='text-danger'>&#8377; {bagDiscount}</span>
                                    </span>
                                </p>
                                {myContext.selectedCoupon && <p className='context'>Coupon Discount
                                    <span className='pull-right'>
                                        <span className='text-danger'>&#8377; {couponDiscount}</span>
                                    </span>
                                </p>}
                                <p className='context'>Delivery Charges
                                    <span className='pull-right' style={{ color: 'rgb(27, 138, 75)' }}>
                                        <span>Free</span>
                                    </span>
                                </p>
                                <hr />
                                <p className='total-payable'>Total Payable <span className='pull-right'>&#8377; {totalValue - bagDiscount - couponDiscount}</span></p>
                                <hr />
                                <p className='saving-alert'>
                                    <button className='btn btn-apply'>
                                        Total Saving on this order &#8377; {bagDiscount + couponDiscount}
                                    </button>

                                </p>
                            </>
                        }
                    </div>
                    <div className='safe-secure'>
                        <p className='content'>
                            <i class="fa-solid fa-shield"></i> Safe and Secure Payments. Easy Returns. 100% Authentic Products.
                        </p>
                    </div>
                </div>
            </div>
        </div>
    )
}
